import React from 'react';
import { StyledPointingArrows, TopPanelCta, TopPanelGroup, TopPanelIcon, TopPanelLabel, TopPanelSubHeading, TopPanelWrapper } from './TopPanel.styles';
import DataPresenter from '../../data-presenter';

var TopPanel = function TopPanel(_a) {
  var topPanel = _a.topPanel,
      widgetActions = _a.widgetActions,
      linkComponent = _a.linkComponent,
      isLoading = _a.isLoading;
  return /*#__PURE__*/React.createElement(TopPanelWrapper, {
    "data-test": 'footer-top-panel'
  }, isLoading || !(topPanel === null || topPanel === void 0 ? void 0 : topPanel.leftAction) ? /*#__PURE__*/React.createElement(TopPanelGroup, {
    right: false,
    "data-test": 'footer-top-panel-group'
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: '2.4rem'
    }
  }, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 6.4,
    height: 6.4
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TopPanelSubHeading, null, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 20,
    height: 2
  })), /*#__PURE__*/React.createElement(TopPanelCta, {
    right: 0,
    to: '#',
    href: '#'
  }, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 20,
    height: 4
  })))) : /*#__PURE__*/React.createElement(TopPanelGroup, {
    right: false,
    "data-test": 'footer-top-panel-group'
  }, /*#__PURE__*/React.createElement(TopPanelIcon, {
    right: false,
    style: {
      backgroundImage: "url('" + topPanel.leftAction.icon.url + "')"
    },
    role: 'img',
    "aria-label": topPanel.leftAction.icon.alternativeText || ''
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TopPanelSubHeading, null, topPanel.leftAction.subHeading || ''), /*#__PURE__*/React.createElement(TopPanelCta, {
    as: topPanel.leftAction.link ? linkComponent : 'div',
    href: topPanel.leftAction.link,
    to: topPanel.leftAction.link,
    onClick: function onClick() {
      if (!topPanel.leftAction.fallbackHandlerId) return;
      var action = topPanel.leftAction.fallbackHandlerId;

      if (!widgetActions[action]) {
        throw new Error('Fallback handler id doesnt match any action creator');
      }

      widgetActions[action]();
    },
    right: 0
  }, /*#__PURE__*/React.createElement(StyledPointingArrows, {
    right: 0
  }), /*#__PURE__*/React.createElement(TopPanelLabel, null, topPanel.leftAction.label)))), isLoading || !(topPanel === null || topPanel === void 0 ? void 0 : topPanel.rightAction) ? /*#__PURE__*/React.createElement(TopPanelGroup, {
    right: true,
    "data-test": 'footer-top-panel-group'
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '2.4rem'
    }
  }, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 6.4,
    height: 6.4
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TopPanelSubHeading, null, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 20,
    height: 2
  })), /*#__PURE__*/React.createElement(TopPanelCta, {
    right: 1,
    to: '#',
    href: '#'
  }, /*#__PURE__*/React.createElement(DataPresenter, {
    nodata: true,
    loading: isLoading,
    width: 20,
    height: 4
  })))) : /*#__PURE__*/React.createElement(TopPanelGroup, {
    right: true,
    "data-test": 'footer-top-panel-group'
  }, /*#__PURE__*/React.createElement(TopPanelIcon, {
    right: true,
    style: {
      backgroundImage: "url('" + topPanel.rightAction.icon.url + "')"
    },
    role: 'img',
    "aria-label": topPanel.rightAction.icon.alternativeText || ''
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TopPanelSubHeading, null, topPanel.rightAction.subHeading || ''), /*#__PURE__*/React.createElement(TopPanelCta, {
    as: topPanel.rightAction.link ? linkComponent : 'div',
    to: topPanel.rightAction.link,
    href: topPanel.rightAction.link,
    onClick: function onClick() {
      if (!topPanel.rightAction.fallbackHandlerId) return;
      var action = topPanel.rightAction.fallbackHandlerId;

      if (!widgetActions[action]) {
        throw new Error('Fallback handler id doesnt match any action creator');
      }

      widgetActions[action]();
    },
    right: 1
  }, /*#__PURE__*/React.createElement(StyledPointingArrows, {
    right: 1
  }), /*#__PURE__*/React.createElement(TopPanelLabel, null, topPanel.rightAction.label)))));
};

export default TopPanel;